// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2aukT","noInteraction":"EventWrapper_noInteraction__1G_PN","pointerPassthrough":"EventWrapper_pointerPassthrough__USjSD"};